"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _default = exports.default = {
  props: ['network'],
  computed: {
    onlineIgnoredUsers() {
      return _lodash.default.filter(this.network.users, u => u.ignore);
    },
    offlineIgnoredUsers() {
      return _lodash.default.filter(this.network.ignored_list, n => !this.network.userByName(n));
    }
  },
  methods: {
    removeIgnore(nick) {
      this.network.ignored_list = this.network.ignored_list.filter(n => n !== nick);
      const user = this.network.userByName(nick);
      if (user) {
        user.ignore = false;
      }
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["IgnoreList"]
window._kiwi_exports.components.IgnoreList = exports.default ? exports.default : exports;
